/**
 * Raven Dashboard Page
 *
 * This is a placeholder component - the actual Raven iframe is rendered
 * by PersistentRaven in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /raven is a valid route)
 * 2. Provide a fallback if PersistentRaven hasn't mounted yet
 *
 * The PersistentRaven component shows/hides itself based on the route,
 * so this page renders nothing (the iframe is shown by the layout).
 */

export function RavenDashboardPage() {
  // PersistentRaven in MainLayout handles the actual iframe rendering
  // This component returns null since the layout takes care of everything
  return null;
}
